// import { useUserStore } from '../../../../modules/Auth/stores/authStore';
import { Typography } from '../../molecules/Typography';
import React, { useState, useEffect } from 'react';
import { Modal } from '../../templates/Modal';
import { Button } from '../../atoms/Button';
// import { sendTrackErrorBQ } from './track';

interface VimeoErrorModalProps {
  vimeoID?: string
}

const VimeoErrorModal: React.FC<VimeoErrorModalProps> = ({ vimeoID = '1026309317' }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  // const user = useUserStore((s) => s.user);

  const MAINTENANCE_END = new Date('2026-04-14T23:59:59-03:00').getTime();

  useEffect(() => {
    if (Date.now() > MAINTENANCE_END) return;
    if (localStorage.getItem('vimeoErrorModalDismissed') === 'true') return;
    setIsOpen(true);
  }, [vimeoID]);

  const onClose = () => {
    localStorage.setItem('vimeoErrorModalDismissed', 'true');
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Aviso!">
      <div className="flex flex-col px-4">
        <Typography type="title" className="text-lg mb-4 text-center">
          ⚠️ Estamos enfrentando uma instabilidade temporária nos vídeos.
        </Typography>
        <Typography className="mt-2">
          Alguns alunos podem ter dificuldades para assistir às videoaulas neste
          momento. Nossa equipe já está trabalhando para resolver o mais rápido
          possível.
        </Typography>
        <Typography className="mt-4">Enquanto isso, aproveite para:</Typography>
        <Typography className="mt-2">✅ Resolver um simulado</Typography>
        <Typography className="mt-2">✅ Praticar com nossos exercícios</Typography>
        <Typography className="mt-2">✅ Revisar resumos e mapas mentais</Typography>
        <Typography className="mt-4">Contamos com sua compreensão!</Typography>
        <Button allowReadOnly onClick={onClose} full variant="contained" className="mt-6">
          Fechar
        </Button>
      </div>
    </Modal>
  );
};

export default VimeoErrorModal;
